import {FooterType} from "../app/FooterType";
import {PasswordValidation, PledgerAction} from "@pledger/frontend-commons";
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {Reducer} from "redux";
import {ChangePasswordActions} from "./ChangePasswordActions";
import {changePasswordWServiceActions} from "../../services/ws/changePassword/changePasswordWServiceActions";

const footerType = (state = FooterType.NONE, action : PledgerAction) => {
    switch (action.type) {
        default:
            return FooterType.NONE;
    }
};

const actualPassword = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case ChangePasswordActions.CHANGE_PASSWORD_ACTUAL_PASSWORD_CHANGE_ACTION.type:
            return action.payload.actualPassword;
        default:
            return state;
    }
};

const newPassword = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case ChangePasswordActions.CHANGE_PASSWORD_NEW_PASSWORD_CHANGE_ACTION.type:
            return action.payload.newPassword;
        default:
            return state;
    }
};

const verifPassword = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case ChangePasswordActions.CHANGE_PASSWORD_VERIF_PASSWORD_CHANGE_ACTION.type:
            return action.payload.verifPassword;
        default:
            return state;
    }
};

const passwordCaracValid = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case ChangePasswordActions.CHANGE_PASSWORD_NEW_PASSWORD_CHANGE_ACTION.type:
            return PasswordValidation.isPasswordLengthValid(action.payload.newPassword);

        default:
            return state;
    }
};

const passwordCapitalValid = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case ChangePasswordActions.CHANGE_PASSWORD_NEW_PASSWORD_CHANGE_ACTION.type:
            return PasswordValidation.isPasswordCapitalValid(action.payload.newPassword);

        default:
            return state;
    }
};

const passwordNumberValid = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case ChangePasswordActions.CHANGE_PASSWORD_NEW_PASSWORD_CHANGE_ACTION.type:
            return PasswordValidation.isPasswordNumberValid(action.payload.newPassword);

        default:
            return state;
    }
};

const passwordSpecialCaracValid = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case ChangePasswordActions.CHANGE_PASSWORD_NEW_PASSWORD_CHANGE_ACTION.type:
            return PasswordValidation.isPasswordSpecialCharValid(action.payload.newPassword);

        default:
            return state;
    }
};

const passwordSent = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case changePasswordWServiceActions.CHANGE_PASSWORD_POST_PASSWORD_SUCCEEDED_ACTION.type:
            return true;

        default:
            return state;
    }
};

const validationId = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case changePasswordWServiceActions.CHANGE_PASSWORD_POST_PASSWORD_SUCCEEDED_ACTION.type:
            return action.payload.data.validationId;
        default:
            return state;
    }
};

const partialPhoneNumber = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case changePasswordWServiceActions.CHANGE_PASSWORD_POST_PASSWORD_SUCCEEDED_ACTION.type:
            return action.payload.data.partialPhoneNumber ?? '';

        default:
            return state;
    }
};

const codeSMS = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case ChangePasswordActions.CHANGE_PASSWORD_CODE_SMS_CHANGE_ACTION.type:
            return action.payload.codeSMS ?? '';

        default:
            return state;
    }
};

const codeSMSError : Reducer  = (state  = false, action: PledgerAction) => {
    switch (action.type) {
        case changePasswordWServiceActions.CHANGE_PASSWORD_POST_PASSWORD_VALIDATION_FAILED_ACTION.type:
            return true;

        case ChangePasswordActions.CHANGE_PASSWORD_CODE_SMS_CHANGE_ACTION.type:
            return false;

        default:
            return state;
    }
};

export interface ChangePasswordPageComponentState extends PledgerPageComponentState {
    actualPassword: string;
    newPassword: string;
    verifPassword: string;
    passwordCaracValid: boolean;
    passwordCapitalValid: boolean;
    passwordNumberValid: boolean;
    passwordSpecialCaracValid: boolean;
    passwordSent: boolean;
    validationId: string;
    partialPhoneNumber: string;
    codeSMS: string;
    codeSMSError: boolean;
}

export const changePassword : Reducer = (state={},action)=>{
    return{
        footerType: footerType(state.footerType, action),
        actualPassword: actualPassword(state.actualPassword, action),
        newPassword: newPassword(state.newPassword, action),
        verifPassword: verifPassword(state.verifPassword, action),
        passwordCaracValid: passwordCaracValid(state.passwordCaracValid, action),
        passwordCapitalValid: passwordCapitalValid(state.passwordCapitalValid, action),
        passwordNumberValid: passwordNumberValid(state.passwordNumberValid, action),
        passwordSpecialCaracValid: passwordSpecialCaracValid(state.passwordSpecialCaracValid, action),
        passwordSent: passwordSent(state.passwordSent, action),
        validationId: validationId(state.validationId, action),
        partialPhoneNumber: partialPhoneNumber(state.partialPhoneNumber, action),
        codeSMS: codeSMS(state.codeSMS, action),
        codeSMSError: codeSMSError(state.codeSMSError, action),
    }
}
